import React, { ReactNode, useEffect } from "react";
import useAuth from "../../Hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

interface MyComponentProps {
    children: ReactNode; // Ensure you define children prop type
}

const GuestGuard:React.FC<MyComponentProps> = ({children}) => {
    // const { isLogin } = useAuth()
    const { isLogin } = useSelector((state:any) => state.AccountReducer)
    const navigate = useNavigate()

    useEffect(() => {
        if (isLogin === "Yes") {
            navigate('/home', { replace: true })
        }
    }, [isLogin, navigate])
    return <>{children}</>
}
export default GuestGuard